import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const dhcfcConfig: MiniGamePageConfig = {
  game: {
    colors: ['#ff6b6b', '#4ecdc4'],
    background: {
      color: '#fafffc',
    },
  },
  titleImage: {
    width: 184,
    height: 62,
    alt: '대전하나시티즌 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
